import React from 'react';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';
import SetFinalPeriod from './SetFinalPeriod';
import SetInitialPeriod from './SetInitialPeriod';

function SetPeriod() {
  return (
    <Wrapper.Default
      flexDirection="column"
      alignItens="start"
      isActive
      width="32%">
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Data entre:
      </span>
      <Wrapper.Default flexDirection="row" width="100%" isActive>
        <SetInitialPeriod />
        <span style={{ fontWeight: 700, padding: '0 0.5rem' }}>a</span>
        <SetFinalPeriod />
      </Wrapper.Default>
    </Wrapper.Default>
  );
}

export default SetPeriod;
